import { render, staticRenderFns } from "./JustificaProposta.vue?vue&type=template&id=60fe7858&"
import script from "./JustificaProposta.vue?vue&type=script&lang=js&"
export * from "./JustificaProposta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports